import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SquarePen } from "lucide-react";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import Modal from "../../../components/portal/Modal";
import HeadingDialog from "../../../components/UI/viewDialogs/HeadingDialog";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import { timeStampToDateAndTime } from "../../../functions/dateTime/timeStampToDateAndTime";
import { formatDate } from "../../../functions/dateTime/formatDate";
import { checkNotNull, checkValue } from "../../../functions/checkValue";
import successIcon from "../../../assets/icons/successIcon.svg";
import { getmaterialTransportStatus } from "../utils/siteHelpers";
import ButtonIcon from "../../../components/UI/buttonUI/ButtonIcon";
import UpdateMaterialTransport from "./UpdateMaterialTransport";
import UsePermissionsClaim from "../../../CustomHooks/UsePermissionsClaim";

export default function MaterialTransportDialog({
  closeDialog,
  details,
  successView,
}) {
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const navigate = useNavigate();
  const { checkPermission } = UsePermissionsClaim();
  const updateMaterial = checkPermission("update_material_transport");
  const updateAnyMaterial = checkPermission("update_any_material_transport");

  return (
    <Modal
      onClose={successView ? undefined : closeDialog}
      closeIcon={!successView}
      modalWidth="view-dialog-content"
    >
      {!successView && <HeadingDialog heading="Transport Details" />}
      {successView && (
        <>
          <img
            src={successIcon}
            alt="messageIcon"
            className="mx-auto mb-1 w-9"
          />
          <p className="view-success-msg-d">
            Material Successfully Transported!
          </p>
        </>
      )}
      <div
        className={`${successView ? "max-h-400" : "max-h-500"} overflow-auto`}
      >
        <div className="view-dialog-content-wrap">
          <DetailRow title="Material" value={details.material.name} />
          <DetailRow
            title="Required Quantity"
            value={checkNotNull(details.quantityRequired)}
          />
          <DetailRow
            title="Quantity Dispatched from Factory"
            value={checkNotNull(details.quantityDispatchedFromFactory)}
          />
          <DetailRow
            title="Quantity Received at Site"
            value={checkNotNull(details.quantityReceivedAtSite)}
          />
          <DetailRow
            title="Quantity Dispatched from Site"
            value={checkNotNull(details.quantityDispatchedFromSite)}
          />
          <DetailRow
            title="Quantity Received at Factory"
            value={checkNotNull(details.quantityReceivedAtFactory)}
          />
          <DetailRow
            title="Excess at factory"
            value={checkNotNull(details.excessAtFactory)}
          />
          <DetailRow
            title="Excess at site"
            value={checkNotNull(details.excessAtSite)}
          />
          <DetailRow
            title="Field Technician"
            value={details.fieldTechnician.fullName}
          />
          <DetailRow title="Supervisor" value={details.supervisor.fullName} />
          <DetailRow
            title="Transport Date"
            value={formatDate(details.dateOfTransport)}
          />
          <DetailRow
            title="Status"
            valueColor={getmaterialTransportStatus(details.status).color}
            value={getmaterialTransportStatus(details.status).status}
          />
          <DetailRow title="Vehicle Number" value={details.vehicleNumber} />
          <DetailRow title="Driver Name" value={details.driverName} />
          <DetailRow title="Remark" value={checkValue(details.remarks)} />
          <DetailRow title="Created By" value={details.createdBy.fullName} />
          <DetailRow
            title="Created At"
            value={timeStampToDateAndTime(details.createdAt)}
          />
          <DetailRow title="Updated By" value={details.updatedBy.fullName} />
          <DetailRow
            title="Updated At"
            value={timeStampToDateAndTime(details.updatedAt)}
          />
        </div>
      </div>
      {!successView &&
        ((details.status === 0 && updateMaterial) || updateAnyMaterial) && (
          <div className="flex justify-center pt-3">
            <ButtonIcon
              btnText="Update"
              Icon={SquarePen}
              size={25}
              onclick={() => setOpenUpdateDialog(true)}
            />
          </div>
        )}
      {openUpdateDialog && (
        <UpdateMaterialTransport
          material={details}
          closeDialog={() => setOpenUpdateDialog(false)}
        />
      )}
      {successView && (
        <div className="pt-5 text-center">
          <GradientButton
            btnText="Ok"
            width="w-28"
            onClick={() => navigate("/material-transport-history")}
          />
        </div>
      )}
    </Modal>
  );
}
